import { render, staticRenderFns } from "./IconMoreOption.vue?vue&type=template&id=72394376&scoped=true"
import script from "./IconMoreOption.vue?vue&type=script&lang=js"
export * from "./IconMoreOption.vue?vue&type=script&lang=js"
import style0 from "./IconMoreOption.vue?vue&type=style&index=0&id=72394376&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72394376",
  null
  
)

export default component.exports